import { render, staticRenderFns } from "./ContainerSpecimenListVideos.vue?vue&type=template&id=678bb354"
import script from "./ContainerSpecimenListVideos.vue?vue&type=script&lang=js"
export * from "./ContainerSpecimenListVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports